// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1EHbW","productName":"Table_productName__3vc7-"};